import { useEffect, useState } from "react";
import { Medal } from "@phosphor-icons/react";
import api from "../lib/api";

export default function AchievementsChips({ uid }) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (!uid) return;
    api.get(`/employees/${uid}/achievements`).then((r) => setItems(r.data.achievements || [])).catch(() => setItems([]));
  }, [uid]);

  if (!items || items.length === 0) return null;

  return (
    <div className="mt-3" data-testid="achievements-row">
      <p className="text-[10px] font-semibold uppercase tracking-wider text-stone-400">Achievements — earned from the record</p>
      <div className="mt-1.5 flex flex-wrap gap-1.5">
        {items.map((a) => (
          <span key={a.key} title={`${a.criteria} — ${a.detail}`}
            className={a.earned
              ? "inline-flex items-center gap-1 rounded-full border border-[#c9982a]/40 bg-[#f7ecd4] px-2.5 py-1 text-xs font-semibold text-[#8a5d14]"
              : "inline-flex items-center gap-1 rounded-full border border-dashed border-stone-300 px-2.5 py-1 text-xs text-stone-400"}
            data-testid={`achievement-${a.key}`}>
            <Medal size={12} weight={a.earned ? "fill" : "regular"} /> {a.label}
          </span>
        ))}
      </div>
    </div>
  );
}
